import React from 'react'

import { ImageDisplayStatus } from './type'

import LazyImage from '@/components/LazyImage'
export interface ImageDisplayProps {
  /** 当前状态 */
  status: ImageDisplayStatus
  /** 图片URL（status为loaded时必需） */
  imageUrl?: string
  /** 删除回调 */
  onRemove?: () => void
  /** 点击回调（用于上传等操作） */
  onClick?: () => void
  /** 自定义样式类名 */
  className?: string
  /** 是否展示这个图片组件 */
  show: boolean
}

const ImageDisplay: React.FC<ImageDisplayProps> = ({
  status,
  imageUrl,
  onRemove,
  onClick,
  className = '',
  show = false,
}) => {
  const baseClassName = `relative rounded-lg cursor-pointer ${className}`

  // 外部传入不展示
  if (!show) {
    return null
  }

  // 加载中状态 - 显示进度环
  if (status === ImageDisplayStatus.LOADING) {
    return (
      <div
        className={`${baseClassName} bg-f-bg-base border-f-border-secondary flex items-center justify-center rounded-lg border `}
      >
        <div className='relative size-6'>
          {/* 旋转的loading圆环 */}
          <svg className='size-6 animate-spin' viewBox='0 0 24 24'>
            <circle
              cx='12'
              cy='12'
              r='10'
              fill='none'
              stroke='#404040'
              strokeWidth='2'
            />
            <circle
              cx='12'
              cy='12'
              r='10'
              fill='none'
              stroke='#FFFFFF'
              strokeWidth='2'
              strokeLinecap='round'
              strokeDasharray='10 52.8'
              strokeDashoffset='0'
            />
          </svg>
        </div>
        <div
          className='absolute right-[-6px] top-0 flex size-3 items-center justify-center rounded-full bg-white shadow-sm'
          onClick={(e) => {
            e.stopPropagation()
            onRemove?.()
          }}
        >
          <span className='i-com--x size-3 text-gray-600'></span>
        </div>
      </div>
    )
  }

  // 错误状态
  if (status === ImageDisplayStatus.ERROR) {
    return (
      <div
        className={`${baseClassName} bg-f-bg-base flex items-center justify-center`}
        onClick={onClick}
      >
        <span className='i-cus--tad-img-fail size-6 text-gray-400'></span>
        <div
          className='absolute right-[-6px] top-0 flex size-3 items-center justify-center rounded-full bg-white shadow-sm'
          onClick={(e) => {
            e.stopPropagation()
            onRemove?.()
          }}
        >
          <span className='i-com--x size-3 text-gray-600'></span>
        </div>
      </div>
    )
  }

  return (
    <div className={baseClassName} onClick={onClick}>
      <div className='relative size-full overflow-hidden rounded-lg'>
        <LazyImage
          className='object-cover'
          src={imageUrl || ''}
          alt=''
          fill
          lazy={false}
        />
      </div>
      <div
        className='absolute right-[-6px] top-0 flex size-3 items-center justify-center rounded-full bg-white shadow-sm'
        onClick={(e) => {
          e.stopPropagation()
          onRemove?.()
        }}
      >
        <span className='i-com--x size-3 text-gray-600'></span>
      </div>
    </div>
  )
}

export default ImageDisplay
